Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.headingTitlePropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _airbnbPropTypes = require('airbnb-prop-types');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _direction = require('react-with-direction/dist/proptypes/direction');

var _direction2 = _interopRequireDefault(_direction);

var _withStyles = require('../themes/withStyles');

var _Shimmer = require('./Shimmer');

var _Shimmer2 = _interopRequireDefault(_Shimmer);

var _Heading = require('./Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _airmojiAdjacent = require('../utils/propTypes/airmojiAdjacent');

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _withLoading = require('./withLoading');

var _withLoading2 = _interopRequireDefault(_withLoading);

var _headingLevelRange = require('../utils/propTypes/headingLevelRange');

var _headingLevelRange2 = _interopRequireDefault(_headingLevelRange);

var _conditionallyRestrictedProp = require('../utils/propTypes/conditionallyRestrictedProp');

var _conditionallyRestrictedProp2 = _interopRequireDefault(_conditionallyRestrictedProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var headingTitlePropTypes = exports.headingTitlePropTypes = {
  noHeading: _propTypes2['default'].bool,
  headingRef: _propTypes2['default'].func
};

var lightPropType = (0, _conditionallyRestrictedProp2['default'])({
  propType: _propTypes2['default'].bool,
  restrictedCondition: function () {
    function restrictedCondition(_ref) {
      var level = _ref.level;
      return level !== 3;
    }

    return restrictedCondition;
  }(),
  restrictedMessage: function () {
    function restrictedMessage(props, propName, componentName) {
      return String(componentName) + ': ' + String(propName) + ' is restricted to level 3';
    }

    return restrictedMessage;
  }()
});

var propTypes = exports.propTypes = Object.assign({}, headingTitlePropTypes, {
  children: (0, _airbnbPropTypes.or)([_airmojiAdjacent.textlikeAdjacentToAirmojiBefore, _airmojiAdjacent.textlikeAdjacentToAirmojiAfter, _textlike2['default']]),
  dir: _direction2['default'], // use the `getTextDirection` util to set this prop
  id: _idProp2['default'],
  inline: _propTypes2['default'].bool,
  inverse: _propTypes2['default'].bool,
  muted: _propTypes2['default'].bool,
  level: _propTypes2['default'].oneOf([1, 2, 3]).isRequired,
  truncate: _propTypes2['default'].bool,
  title: (0, _airbnbPropTypes.requiredBy)('truncate', _propTypes2['default'].string),
  light: lightPropType
});

var finalPropTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, _withLoading.withLoadingPropTypes, propTypes));

var defaultProps = {
  dir: undefined,
  headingRef: function () {
    function headingRef() {}

    return headingRef;
  }(),

  id: undefined,
  inline: false,
  inverse: false,
  muted: false,
  noHeading: false,
  truncate: false,
  title: null
};

var contextTypes = {
  headingLevel: _headingLevelRange2['default']
};

function getTag(inline) {
  if (inline) {
    return 'span';
  }

  return 'div';
}

var SHIMMER = _react2['default'].createElement(_Shimmer2['default'], null);

function Title(_ref2, context) {
  var css = _ref2.css,
      children = _ref2.children,
      dir = _ref2.dir,
      headingRef = _ref2.headingRef,
      id = _ref2.id,
      inline = _ref2.inline,
      inverse = _ref2.inverse,
      level = _ref2.level,
      muted = _ref2.muted,
      styles = _ref2.styles,
      isLoading = _ref2.isLoading,
      noHeading = _ref2.noHeading,
      truncate = _ref2.truncate,
      title = _ref2.title,
      light = _ref2.light;
  var headingLevel = context.headingLevel;

  // don't render with Heading when noHeading is passed as true

  var renderHeading = !noHeading;

  if (renderHeading && !headingLevel) {
    throw new Error('No `headingLevel` context was passed to `<Title />`. Make sure you are either using this inside of a `<HeadingSection />` component, or passing the prop `noHeading` as `true` if you’re sure that you don’t need heading tags.');
  }

  var Tag = getTag(inline, renderHeading);

  // let Heading render the shimmer on its own when present
  var inner = isLoading && !renderHeading ? SHIMMER : children;

  if (renderHeading) {
    inner = _react2['default'].createElement(
      _Heading2['default'],
      { id: id, inline: inline || truncate, headingRef: headingRef },
      inner
    );
  }

  return _react2['default'].createElement(
    Tag,
    _extends({}, css(styles.title, level === 1 && styles.level1, level === 2 && styles.level2, level === 3 && styles.level3, inverse && styles.inverse, light && styles.light, muted && styles.muted, truncate && styles.truncate), {
      dir: dir
      // the id is set on the Heading directly when present
      , id: renderHeading ? null : id,
      title: isLoading ? null : title
    }),
    inner
  );
}

Title.componentCategory = 'Core';
Title.displayName = 'Title';
Title.propTypes = finalPropTypes;
Title.defaultProps = defaultProps;
Title.contextTypes = contextTypes;

exports['default'] = (0, _withLoading2['default'])((0, _withStyles.withStyles)(function (_ref3) {
  var color = _ref3.color,
      font = _ref3.font;
  return {
    title: Object.assign({}, font.bold, {
      color: color.core.hof,
      fontFamily: font.FONT_FAMILY,

      // Override text margins defined by O2 or Bootstrap
      margin: 0,
      wordWrap: 'break-word'
    }),

    level1: Object.assign({}, font.title1),

    level2: Object.assign({}, font.title2),

    level3: Object.assign({}, font.title3),

    inverse: {
      color: color.white
    },

    light: Object.assign({}, font.light),

    muted: {
      color: color.textMutedLarge,

      '@media print': {
        color: color.printOverrides.textMutedLarge
      }
    },

    truncate: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
}, { pureComponent: true })(Title));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Title.js
// module id = 39
// module chunks = 168707334958949